import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '../../../api/useApi'

interface FinalizeTempUserParams {
  personnummer: string
}

export const useFinalizeTempUser = () => {
  return useMutation(
    ['finalizeTempUser'],
    async (data: FinalizeTempUserParams) =>
      await apiClient
        .finalizeTempUser(
          data,

          {
            withCredentials: true,
          }
        )
        .then((res) => res.data)
  )
}
